import { render, staticRenderFns } from "./SpeichernErfolgreichModal.vue?vue&type=template&id=36198824"
import script from "./SpeichernErfolgreichModal.vue?vue&type=script&lang=js"
export * from "./SpeichernErfolgreichModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports